import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import { Footer } from './containers';
import { Navbar, Preloader } from './@/components';
import ReactGA from "react-ga4";
import { collection, getDocs } from 'firebase/firestore';
import { db } from "./firebase";
import LazyLoad from 'react-lazyload';

import Home from './screens/home/Home';
import Work from './screens/work/Work';
import TeamDetails from './screens/teamDetails/TeamDetails';
import ArticleDetails from './screens/articleDetails/ArticleDetails';
import Learn from './screens/learn/Learn';
import Contact from './screens/contact/Contact';
import About from './screens/about/About';
import Register from './screens/register/Register';
import ProjectDetails from './screens/projectDetails/projectDetails';
import IssueDetails from './screens/issueDetails/IssueDetails';
import CaseStudy from './screens/caseStudy/CaseStudy';
import Issues from './screens/issues/Issues';
import Interviews from './screens/interviews/Interviews';
import InterviewsDetails from './screens/interviewDetails/InterviewDetails';
import NotFound from './screens/notFound/NotFound';
import Maintenance from './screens/maintenance/Maintenance';

const TRACKING_ID = "G-GQE2TFY87X"; 
ReactGA.initialize(TRACKING_ID);

ReactGA.send({ 
  hitType: "pageview", 
  page: window.location.pathname,
  title: "Custom Title"
});

const sectionVariants = {
  hidden: { opacity: 1, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const ArrowUpIcon = () => (
  <svg
    className="arrow-up-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="5 12 12 5 19 12" transform="rotate(90 12 12)"></polyline>
    <line x1="12" y1="19" x2="12" y2="5" transform="rotate(90 12 12)"></line>
  </svg>
);

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop > 0.60 * (documentHeight - windowHeight)) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {showButton && (
        <div className="back-to-top" onClick={scrollToTop}>
          <ArrowUpIcon />
        </div>
      )}
    </>
  );
};

const App = () => {
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const fetchArticles = async () => {
      setProgress(30);
      try {
        const newsRef = collection(db, 'news');
        const querySnapshot = await getDocs(newsRef);
        const fetchedArticles = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setArticles(fetchedArticles);
        setProgress(100);
      } catch (err) {
        console.error('Error fetching articles:', err);
        setProgress(100);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  const categorizeArticles = (category) => articles.filter(article => article.category.toLowerCase() === category.toLowerCase());

  return (
    <Router>
      <div className="App">
        {loading ? (
          <Preloader />
        ) : (
          <>
            <Navbar />
            

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/stories" element={<Work />} />
              <Route path="/stories/:slug" element={<CaseStudy />} /> 
              <Route path="/work/:slug" element={<ProjectDetails />} /> 
              <Route path="/team/:slug" element={<TeamDetails />} />
              <Route path="/article/:id" element={<ArticleDetails />} />
              <Route path="/case-study" element={<Learn articles={articles} />} />
              <Route path="/issues/:id" element={<IssueDetails />} />
              <Route path="/interviews/:id" element={<InterviewsDetails />} />
              <Route path="/interviews" element={<Interviews />} />
              <Route path="/events" element={<Contact />} />
              <Route path="/articles" element={<About />} />
              <Route path="/register" element={<Register />}/>
              <Route path="/ideas/:id" element={<CaseStudy />} />
              <Route path="/issues" element={<Issues />} />
              <Route path="*" element={<Maintenance />} />
            </Routes>

            <Footer />
            <ScrollToTop />
          </>
        )}
      </div>
    </Router>
  );
};

export default App;








// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
// import './App.css';
// import { Footer } from './containers';
// import { Navbar, Preloader } from './@/components';
// import ReactGA from "react-ga4";
// import { collection, getDocs } from 'firebase/firestore';
// import { db } from "./firebase";
// import LazyLoad from 'react-lazyload';

// import Home from './screens/home/Home';
// import Work from './screens/work/Work';
// import TeamDetails from './screens/teamDetails/TeamDetails';
// import ArticleDetails from './screens/articleDetails/ArticleDetails';
// import Learn from './screens/learn/Learn';
// import Contact from './screens/contact/Contact';
// import About from './screens/about/About';
// import Register from './screens/register/Register';
// import ProjectDetails from './screens/projectDetails/projectDetails';
// import IssueDetails from './screens/issueDetails/IssueDetails';
// import CaseStudy from './screens/caseStudy/CaseStudy';
// import Issues from './screens/issues/Issues';
// import Interviews from './screens/interviews/Interviews';
// import InterviewsDetails from './screens/interviewDetails/InterviewDetails';
// import NotFound from './screens/notFound/NotFound';
// import Maintenance from './screens/maintenance/Maintenance';

// const TRACKING_ID = "G-GQE2TFY87X"; 
// ReactGA.initialize(TRACKING_ID);

// ReactGA.send({ 
//   hitType: "pageview", 
//   page: window.location.pathname,
//   title: "Custom Title"
// });

// const sectionVariants = {
//   hidden: { opacity: 1, y: 50 },
//   visible: { opacity: 1, y: 0 },
// };

// const ArrowUpIcon = () => (
//   <svg
//     className="arrow-up-icon"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polyline points="5 12 12 5 19 12" transform="rotate(90 12 12)"></polyline>
//     <line x1="12" y1="19" x2="12" y2="5" transform="rotate(90 12 12)"></line>
//   </svg>
// );

// const ScrollToTop = () => {
//   const [showButton, setShowButton] = useState(false);
//   const { pathname } = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollTop = window.pageYOffset;
//       const windowHeight = window.innerHeight;
//       const documentHeight = document.documentElement.scrollHeight;

//       if (scrollTop > 0.60 * (documentHeight - windowHeight)) {
//         setShowButton(true);
//       } else {
//         setShowButton(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   return (
//     <>
//       {showButton && (
//         <div className="back-to-top" onClick={scrollToTop}>
//           <ArrowUpIcon />
//         </div>
//       )}
//     </>
//   );
// };

// // Layout components
// const MainLayout = ({ children }) => (
//   <>
//     <Navbar />
//     {children}
//     <Footer />
//     <ScrollToTop />
//   </>
// );

// const MaintenanceLayout = ({ children }) => (
//   <>
//     {children}
//   </>
// );

// const App = () => {
//   const [progress, setProgress] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [articles, setArticles] = useState([]);
  
//   // For the maintenance mode
//   const isMaintenanceMode = true; // You can set this based on your requirements

//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       setLoading(false);
//     }, 2000);

//     return () => clearTimeout(timeout);
//   }, []);

//   useEffect(() => {
//     const fetchArticles = async () => {
//       setProgress(30);
//       try {
//         const newsRef = collection(db, 'news');
//         const querySnapshot = await getDocs(newsRef);
//         const fetchedArticles = querySnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));
//         setArticles(fetchedArticles);
//         setProgress(100);
//       } catch (err) {
//         console.error('Error fetching articles:', err);
//         setProgress(100);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchArticles();
//   }, []);

//   const categorizeArticles = (category) => articles.filter(article => article.category.toLowerCase() === category.toLowerCase());

//   // If in maintenance mode, show only maintenance page
//   if (isMaintenanceMode) {
//     return (
//       <Router>
//         <div className="App">
//           {loading ? (
//             <Preloader />
//           ) : (
//             <MaintenanceLayout>
//               <Maintenance />
//             </MaintenanceLayout>
//           )}
//         </div>
//       </Router>
//     );
//   }

//   // Regular site with all routes
//   return (
//     <Router>
//       <div className="App">
//         {loading ? (
//           <Preloader />
//         ) : (
//           <MainLayout>
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/stories" element={<Work />} />
//               <Route path="/stories/:slug" element={<CaseStudy />} /> 
//               <Route path="/work/:slug" element={<ProjectDetails />} /> 
//               <Route path="/team/:slug" element={<TeamDetails />} />
//               <Route path="/article/:id" element={<ArticleDetails />} />
//               <Route path="/case-study" element={<Learn articles={articles} />} />
//               <Route path="/issues/:id" element={<IssueDetails />} />
//               <Route path="/interviews/:id" element={<InterviewsDetails />} />
//               <Route path="/interviews" element={<Interviews />} />
//               <Route path="/events" element={<Contact />} />
//               <Route path="/articles" element={<About />} />
//               <Route path="/register" element={<Register />}/>
//               <Route path="/ideas/:id" element={<CaseStudy />} />
//               <Route path="/issues" element={<Issues />} />
//               <Route path="*" element={<NotFound />} />
//             </Routes>
//           </MainLayout>
//         )}
//       </div>
//     </Router>
//   );
// };

// export default App;